(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/helpers/blocking-info-helper.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/helpers/blocking-info-helper.js');

'use strict';

const {
  getLastSuspension
} = svs.accountservicesReact.deposit.helpers.suspensionHelper;
const {
  getSuspensions,
  getCurrentStatus,
  getNetLossRestrictions,
  getDepositRestrictions,
  getDayTimeLimit
} = svs.accountservicesReact.deposit.services.depositService;
const {
  amountLimits
} = svs.accountservicesReact.deposit.constants;

const getBlockingInfo = async maxLimitRemaining => {

  if (svs.core.userSession.isBlocked()) {
    return {
      isBlockedNAR: true
    };
  }

  const currentStatus = await getCurrentStatus();
  if (currentStatus !== null && currentStatus !== void 0 && currentStatus.currentStatus.includes('DEPOSITS_SUSPENDED')) {
    const {
      amountLimit,
      endTime
    } = await getNetLossRestrictions();
    const netLossRestrictions = {
      amountLimit,
      endTime
    };
    if (netLossRestrictions !== null && netLossRestrictions !== void 0 && netLossRestrictions.amountLimit) {
      return {
        netLossRestrictions
      };
    }

    const {
      showFirstDialog,
      showSecondDialog,
      depositsMade
    } = await getDepositRestrictions();
    const depositRestrictions = {
      showFirstDialog,
      showSecondDialog,
      depositsMade
    };
    if (depositRestrictions.showFirstDialog || depositRestrictions.showSecondDialog) {
      return {
        depositRestrictions
      };
    }

    return {
      ttRestriction: true
    };
  }

  const suspensionsResponse = await getSuspensions();
  if (suspensionsResponse) {
    const lastSuspension = getLastSuspension(suspensionsResponse);
    if (lastSuspension) {
      return {
        suspensions: lastSuspension
      };
    }
  }

  const dayTimeLimit = await getDayTimeLimit();
  if (dayTimeLimit !== null && dayTimeLimit !== void 0 && dayTimeLimit.dayTimeExpired) {
    return {
      dayTimeLimit
    };
  }

  if (maxLimitRemaining < amountLimits.MIN) {
    return {
      maxLimitRemaining
    };
  }

  return false;
};
svs.accountservicesReact.deposit.helpers.blockingInfoHelper = {
  getBlockingInfo
};

 })(window);